import api from './api';

export const getSuppliers = () => api.get('/suppliers');
export const getSupplier = (id) => api.get(`/suppliers/${id}`);
export const createSupplier = (data) => api.post('/suppliers', data);
export const updateSupplier = (id, data) => api.put(`/suppliers/${id}`, data);
export const deleteSupplier = (id) => api.delete(`/suppliers/${id}`);

/** Log a Suppliers Analysis page action (hide/restore/reset) for user logs. */
export const logSuppliersAnalysisAction = (action, details = {}) =>
    api.post('/suppliers-analysis/log', { action, details });

/** Cost categories (Rompslomp ledger accounts) and BTW treatments for the accounting part of the supplier form. */
export const getSupplierAccountingOptions = () => api.get('/suppliers/accounting-options');
